import { Button } from 'antd'
import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

import { DRAWER_TYPE } from '../../../redux/drawerSlice'
import { useAppSelector } from '../../../redux/hooks'
import { lvDetailPath } from '../../utils/paths'

export const LvDetailDrawerHeader: FunctionComponent = () => {
  const lv = useAppSelector(state => state.drawer?.[DRAWER_TYPE.LV])

  if (!lv?.lvCode || !lv.lvNumber) {
    return null
  }
  return (
    <div className="flex justify-between items-center">
      <div>Náhled listu vlastnictví</div>
      <div className="flex space-x-2 items-center">
        <Link
          to={lvDetailPath(lv.lvCode, lv.lvNumber)}
          target="_blank"
          title="Otevřít detail LV v novém okně"
        >
          <Button type="primary">Přejít na detail</Button>
        </Link>
      </div>
    </div>
  )
}
